import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button } from '@chakra-ui/react';

import React from 'react';

type DeleteDialogProps = {
    onDelete: () => void;
    item: string;
    onClose: () => void;
    isOpen: boolean;
    id: any;
};

export const DeleteDialog = (props: DeleteDialogProps) => {

    const { onDelete, item, isOpen, onClose } = props;
    let { id } = props;
    id = React.useRef();
  
    return (
        <AlertDialog
          isOpen={isOpen}
          leastDestructiveRef={id}
          onClose={onClose}
          isCentered
        >
          <AlertDialogOverlay>
            <AlertDialogContent>
              <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                Delete {item}
              </AlertDialogHeader>
  
              <AlertDialogBody>
                Are you sure? You can&apos;t undo this action afterwards.
              </AlertDialogBody>
  
              <AlertDialogFooter>
                <Button ref={id} onClick={onClose}>
                  Cancel
                </Button>
                <Button colorScheme='red' onClick={onDelete} ml={3}>
                  Delete
                </Button>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>
    );
  };